module.exports = __webpack_public_path__ + "img/message-icon.9e5d8407.svg";